module.exports = __webpack_public_path__ + "70dc75b760d26c52c934b3db8344d2f5.pdf";